export default __webpack_public_path__ + "static/media/instapic.9032d479.jpg";